import angular from 'angular';
import socialSecurityHeaderEmployeeComponent from './socialSecurityHeaderEmployee.component';

let socialSecurityHeaderEmployeeModule = angular.module('socialSecurityHeaderEmployee', [
])

.component('socialSecurityHeaderEmployee', socialSecurityHeaderEmployeeComponent)

.name;

export default socialSecurityHeaderEmployeeModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityHeaderEmployee/socialSecurityHeaderEmployee.js